export function generateAva(text) {
  const clean = text.replace(/[^a-z0-9áéíóúñü .,_-]/gim, '');
  const words = clean.split(' ');

  const nodup = words.reduce(
    (acc, curr) => {
      if (!acc.includes(curr)) {
        return [...acc, curr];
      }
      return acc;
    },
    ['']
  );

  if (nodup.length > 2)
    return nodup[1][0].toUpperCase() + nodup[2][0].toLowerCase();
  if (nodup.length === 2 && nodup[1].length > 1)
    return nodup[1][0].toUpperCase() + nodup[1][1].toLowerCase();
  if (nodup.length === 2 && nodup[1].length === 1)
    return nodup[1][0].toUpperCase();
  return 'Un';
}
